import React from 'react';
import styled from 'styled-components';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { ScoreDetails } from 'ff/debrief/models';
import SegmentScore from 'ff/debrief/components/segments/SegmentScore';
import VrefInputField from 'ff/debrief/components/segments/VrefInputField';
import ApproachSelector from 'ff/debrief/components/segments/ApproachSelector';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';

interface Props {
    scoreDetails: ScoreDetails[];
}

const ScoreBreakDown = (props: React.PropsWithChildren<Props>) => {
    return (
        <TableContainer sx={{ pb: 1, height: 285 }}>
            <InputRow>
                <Box sx={{ width: 600 }}>
                    <VrefInputField />
                </Box>
                <ApproachSelector>
                    <InputLabel variant="standard">Approach</InputLabel>
                </ApproachSelector>
            </InputRow>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell></TableHeaderCell>
                        <TableHeaderCell>Score</TableHeaderCell>
                        <TableHeaderCell>Goal</TableHeaderCell>
                        <TableHeaderCell>Actual</TableHeaderCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.scoreDetails &&
                        props.scoreDetails.map(sd => (
                            <TableRow key={sd.id}>
                                <LabelCell>{sd.label}</LabelCell>
                                <ValueCell>
                                    <SegmentScore score={sd.score} />
                                </ValueCell>
                                <ValueCell>{sd.goal}</ValueCell>
                                <ValueCell>{sd.actual}</ValueCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

const TableHeaderCell = styled(TableCell)`
    background-color: #d8dadb;
    color: #6d767d;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
`;

const LabelCell = styled(TableCell)`
    color: #222;
    text-align: right;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
`;
const ValueCell = styled(TableCell)`
    color: #222;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
`;

const InputRow = styled(Box)`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
`;

export default ScoreBreakDown;
